// extracted by mini-css-extract-plugin
export default {"audio-selection-btn":"AudioSwitch_audio-selection-btn__ArbM3","audio-selection-container":"AudioSwitch_audio-selection-container__KotEX"};